module.exports = __webpack_public_path__ + "static/face-mask-bunny-8sec-f63950f671544036abffe420d4fa682e.svg";